import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";

import CloseSvg from "@core/svgs/close.svg";

import { smartphoneFilterOptionsPropTypes } from "sharedPropTypes";
import { Label } from "components/atoms";

const StyledLabel = styled(Label)`
  margin-right: ${({ theme }) => theme.space.xs}px;
  margin-bottom: ${({ theme }) => theme.space.xs}px;
  cursor: pointer;
`;

const StyledSpan = styled.span`
  margin-right: 0.5em;
`;

const mapName = (name) => {
  switch (name) {
    case "priceRange":
      return "Preis";
    case "oneTimePriceFromRange":
      return "Gerätepreis";
    case "volumeRange":
      return "Datenvolumen";
    case "speedRange":
      return "Datengeschwindigkeit";
    case "displayRange":
      return "Bildschirmdiagonale";
    default:
      return name;
  }
};

const EnhancedLabel = (key, name, onClick) => (
  <StyledLabel onClick={() => onClick(key, name)} key={key + name}>
    <StyledSpan>{mapName(name)}</StyledSpan>
    <CloseSvg viewBox="0 0 16 10" />
  </StyledLabel>
);

const FilterLabelList = ({ filters, onClick }) =>
  Object.keys(filters).map((key) => {
    if (Array.isArray(filters[key])) {
      return filters[key].map((filter) =>
        EnhancedLabel(key, filter.name, onClick)
      );
    }
    return EnhancedLabel(key, key, onClick);
  });

FilterLabelList.propTypes = {
  filters: smartphoneFilterOptionsPropTypes,
  onClick: PropTypes.func,
};

export default FilterLabelList;
